// extracted by mini-css-extract-plugin
export default {"container":"TJ-z","dimension":"UJ-z","dimensionLabels":"VJ-z"};